module.exports = __webpack_public_path__ + "img/category_19.84c9487b.png";